const CAN_PROVINCE_MAP = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  NT: "Northwest Territories",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon",
} as const;

type CanProvinceAbbreviation = keyof typeof CAN_PROVINCE_MAP;

const CAN_PROVINCE_ABBREVIATIONS = Object.keys(
  CAN_PROVINCE_MAP,
) as CanProvinceAbbreviation[];

export type { CanProvinceAbbreviation };

export { CAN_PROVINCE_ABBREVIATIONS, CAN_PROVINCE_MAP };
